export default __webpack_public_path__ + "static/water_w.a965c4fd69d9c5d27dd387e63ab1868e.png";